import React from 'react';
import PropTypes from 'prop-types';
import WordBox from '../WordBox';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const getPhonemeStatus = (phonemes, index) => phonemes.includes(index);

const PhonemicAwarenessAssessmentRow = ({ line, itemLevelDetails, selfCorrectedMark }) => {
    const { incorrectPhonemes, selfCorrectedPhonemes, segments, score, maxScore } =
        itemLevelDetails;
    const { segmentation, word } = line;
    return (
        <div className="row assessment-row">
            <div data-test-id="psf-word" className="col-2 col">
                {word}
            </div>
            <div className="col-7 col">
                {segmentation.map((segment, index) => (
                    <WordBox
                        key={generateReactKey(index)}
                        word={`/${segment}/`}
                        isIncorrect={getPhonemeStatus(incorrectPhonemes, index)}
                        isSelfCorrected={getPhonemeStatus(selfCorrectedPhonemes, index)}
                        segmentation={segmentation}
                        segments={segments}
                        columnIndex={index}
                        selfCorrectedMark={selfCorrectedMark}
                    />
                ))}
            </div>
            <div data-test-id="psf-score" className="col-3 col">
                {score}/{maxScore}
            </div>
        </div>
    );
};

PhonemicAwarenessAssessmentRow.defaultProps = {
    itemLevelDetails: {},
    selfCorrectedMark: 'sc',
};

PhonemicAwarenessAssessmentRow.propTypes = {
    line: PropTypes.object.isRequired,
    itemLevelDetails: PropTypes.object,
    selfCorrectedMark: PropTypes.string,
};

export default PhonemicAwarenessAssessmentRow;
